export const PROPERTIES_SET_LIGHT_DIRECTION = 'PROPERTIES_SET_LIGHT_DIRECTION';
export const propertiesSetLightDirection = (direction) => ({ type: PROPERTIES_SET_LIGHT_DIRECTION, payload: direction });

export const PROPERTIES_SET_EYE_DIRECTION = 'PROPERTIES_SET_EYE_DIRECTION';
export const propertiesSetEyeDirection = (direction) => ({ type: PROPERTIES_SET_EYE_DIRECTION, payload: direction });

export const PROPERTIES_UPDATE_PROPERTY = 'PROPERTIES_UPDATE_PROPERTY';
export const propertiesUpdateProperty = (data) => ({ type: PROPERTIES_UPDATE_PROPERTY, payload: data });
